<script lang="ts">
  export let link = '';
  export let target = undefined;
  export let iconUrl = '';
  export let iconAlt = '';
  export let title = '';
  export let subTitle = '';
  export let titleIcon = '';
  export let titleIconAlt = '';
  export let theme;
  export let noArrow = false
  export let noArrowHover = false
</script>

<style lang="scss">
  $title-color: #1d2029;
  $sub-title-color: #999b9f;

  .menu-item {
    padding: 12px;
    line-height: normal;
  }
  .menu-item:not(:first-child) {
    margin-top: 2px;
  }
  .menu-item:hover {
    background: #f4f6fb;
  }
  .sub-title,
  .title {
    white-space: normal;
  }
  .title {
    color: $title-color;
  }
  .sub-title {
    margin-top: 4px;
    color: $sub-title-color;
  }
  .sub-menu-title-icon {
    height: 14px;
  }
  .arrow {
    color: $title-color;
    opacity: 0;
    transition: transform 0.2s ease-in, opacity 0.2s ease-in, -webkit-transform 0.2s ease-in;
  }
  .menu-item:hover .arrow {
    transform: translateX(4px);
    opacity: 1;
  }
  .no-hover .arrow {
    opacity: 1;
  }
  .no-hover:hover .arrow {
    opacity: 1;
  }
  .menu-item.dark {
    &:hover {
      background: rgba(255,255,255, 0.06);
    }
    .title {
      color: #fff;
    }
    .sub-title {
      line-height: 16px;
      color: #888B94;
    }
    .arrow-con {
      .arrow {
        color: #fff;
      }
    }
  }
  @media screen and (max-width: 1280px) {
    .menu-item {
      padding: 8px 12px;
    }
  }
  .arrow-con {
    width: 16px;
  }
</style>

<a class="menu-item noa df fdr aic br8 cp" class:no-hover={noArrowHover} class:dark={theme === 'dark'} href={link} {target} on:click on:mouseenter rel="noopener">
  {#if iconUrl}
    <div class="df mr16"><img width="24" alt={iconAlt} src={iconUrl} /></div>
  {:else if $$slots['circle-suffix']}
    <div class="df mr16"><slot name="circle-suffix" /></div>
  {/if}
  <div class="wp100 df aic jcsb f14">
    <div>
      <div class="title df aic fw2">
        {title}
        <slot name="title-suffix" />
        {#if titleIcon}<img class="sub-menu-title-icon ml4" height="14" src={titleIcon} alt={titleIconAlt} />{/if}
      </div>
      {#if subTitle}
        <div class="sub-title f12 fw1">{subTitle}</div>
      {/if}
    </div>
    {#if !noArrow}
      <div class="arrow-con df ml12 lh20"><i class="arrow iconfont dib f16 fw1">&#xe755;</i></div>
    {/if}
  </div>
</a>
